export default "__VITE_ASSET__CkjJajz8__"